import styled from "styled-components";

export const TopSectionBox = styled.div<{alignStart: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${props => props.alignStart ? "flex-start": "center"};
    width: 100%;
`